"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var Validator_1 = require("../Validator");
/**
 * Checks whether the given number is greater (or equal) than defined value.
 * @author OPt
 */


var NumberGreaterThanValidator =
/*#__PURE__*/
function (_Validator_1$Validato) {
  _inherits(NumberGreaterThanValidator, _Validator_1$Validato);

  function NumberGreaterThanValidator(limit) {
    var _this;

    var equalsValid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, NumberGreaterThanValidator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NumberGreaterThanValidator).call(this, ValidationLevel_1.ValidationLevel.Fast));
    _this.limit = limit;
    _this.equalsValid = equalsValid;
    return _this;
  }

  _createClass(NumberGreaterThanValidator, [{
    key: "doValidate",
    value: function doValidate(value) {
      if (!this.equalsValid && value === this.limit || value < this.limit) {
        return new ValidationResult_1.ValidationError(NumberGreaterThanValidator.OUT_OF_BOUNDS_ERRORS, this.limit);
      }

      return new ValidationResult_1.ValidationSuccess(value);
    }
  }]);

  return NumberGreaterThanValidator;
}(Validator_1.Validator);

exports.NumberGreaterThanValidator = NumberGreaterThanValidator;
NumberGreaterThanValidator.OUT_OF_BOUNDS_ERRORS = 'NUMBER_BELOW_MIN';